// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2apjD","description":"PatientConsentPreview_description__1fMl6"};